export const printToFrameSizeMap = {
  3: 'cl8d2sjel000c35a010c9twzy',
  5: 'clcuu08sr000c35a0x6i9vqad',
  11: 'cl8d2sed0000b35a0dp6zygjp',
  12: 'cl8d2ph0d000335a0hy4iec9t',
  22: 'clcuu0fs4000d35a0i12tdz07',
};
